import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  QueryList,
  ViewChildren,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-affiliation-graph',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './affiliation-graph.component.html',
  styleUrls: ['./affiliation-graph.component.scss'],
})
export class AffiliationGraphComponent implements OnInit, AfterViewInit {
  rcmId!: string;
readonly HCA_LIMIT = 20;
readonly HCP_LIMIT = 20;
  parent: any[] = [];
  hca: any[] = [];
  hcp: any[] = [];
returnUrl: string = '';
  selectedNodeType: string = '';
  selectedNodeName: string = '';
  isHcpGraphMode = false;
  hierarchyNodes: any[] = [];
  topParentNode: any = null;
  graph: any = {
    leftChildren: [],
    rightChildren: [],
  };
  affiliationSummary: any = {};
  selectedParent: any = null;
  hasHcpChildren = false;
  hasHcaChildren = false;
  @ViewChildren('hierarchyNode')
  hierarchyNodeRefs!: QueryList<ElementRef>;

  @ViewChild('leftStack')
  leftStackRef!: ElementRef;

  @ViewChild('rightStack')
  rightStackRef!: ElementRef;

  leftLine: any = null;
  rightLine: any = null;
  parentLines: any[] = [];
  constructor(
  private router: Router
) {}
  ngOnInit(): void {
    const state = history.state;
    this.returnUrl = state.returnUrl || '/main/crt/affiliation-view';
this.selectedNodeName = state.name;
this.affiliationSummary = {
  searchedLevel: this.selectedNodeType,
  rcmId: this.rcmId,
  name: this.selectedNodeName,
  totalL3Children: this.hca?.length || 0,
  totalHcpChildren: this.hcp?.length || 0,
};
    this.rcmId = state.rcmId;

    this.parent = state.parent || [];
    this.hca = state.hca || [];
    this.hcp = state.hcp || [];

    this.selectedParent = state.selectedParent || null;

    this.selectedNodeType = state.type;
    this.selectedNodeName = state.name;

    // 🔥 detect HCP special graph mode
    // this.isHcpGraphMode = this.selectedNodeType?.toUpperCase() === 'HCP'
    //   && !!this.selectedParent;

    this.buildGraph();
    this.buildAffiliationSummary();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.drawLines();
    });

    window.addEventListener('resize', () => {
      this.drawLines();
    });
  }

  buildGraph() {
    this.isHcpGraphMode = this.selectedNodeType?.toUpperCase() === 'L4';

    // =====================================
    // 🔥 HCP MODE ONLY (DO NOT TOUCH HCA)
    // =====================================
    if (this.isHcpGraphMode) {
      const chain = this.selectedParent?.hca_hierarchy_chain?.[0];

      const upward = this.selectedParent?.upward_hierarchy || [];

      const nameMap = new Map<string, string>();

      // -----------------------------
      // SAFE name lookup
      // -----------------------------
      upward.forEach((x: any) => {
        if (x.parent_hca_rcm_id) {
          nameMap.set(
            x.parent_hca_rcm_id,
            x.parent_hca_name || x.org_name || '',
          );
        }

        if (x.source_rcm_id) {
          nameMap.set(x.source_rcm_id, x.source_hca_name || x.org_name || '');
        }
      });

      const hcpHierarchy: any[] = [];

      // -----------------------------
      // IMPORTANT FIX:
      // ensure correct order + null safety
      // -----------------------------

      const levels = [
        { id: chain?.l1_id, level: 'L1' },
        { id: chain?.l2_id, level: 'L2' },
        { id: chain?.l3_id, level: 'L3' },
      ];

      levels.forEach((item) => {
        if (!item.id) return;

        hcpHierarchy.push({
          id: item.id,
          name: nameMap.get(item.id) || `${item.level} HCA`,
          level: item.level,
          type: 'HCA',
          isSelected: false,
        });
      });

      // -----------------------------
      // Selected HCP node
      // -----------------------------
      hcpHierarchy.push({
        id: this.rcmId,
        name: this.selectedNodeName,
        level: 'HCP',
        type: 'HCP',
        isSelected: true,
      });

      this.hierarchyNodes = hcpHierarchy;

      // -----------------------------
      // CHILDREN (UNCHANGED SAFE)
      // -----------------------------
      const hcpChildren = this.hcp.map((x: any) => ({
  id: x.target_hcp_rcm_id,
  name: `${x.target_hcp_first_name || ''} ${x.target_hcp_last_name || ''}`.trim(),
  type: 'HCP',
}));

const hcaChildren = this.hca.map((x: any) => ({
  id: x.target_hca_rcm_id,
  name: x.target_hca_name,

  // IMPORTANT
  level:
    x.target_level ||
    x.target_hca_level ||
    x.level ||
    'HCA',

  type: 'HCA',
}));

this.graph.leftChildren = this.limitChildren(
  hcpChildren,
  this.HCP_LIMIT,
  'HCP'
);

this.graph.rightChildren = this.limitChildren(
  hcaChildren,
  this.HCA_LIMIT,
  'HCA'
);

      this.hasHcpChildren = this.graph.leftChildren.length > 0;
      this.hasHcaChildren = this.graph.rightChildren.length > 0;
      return;
    }

    // =====================================
    // HCA MODE (UNCHANGED - KEEP AS IS)
    // =====================================
    this.buildHierarchy();

    const hcpChildren = this.hcp.map((x: any) => ({
  id: x.target_hcp_rcm_id,
  name: `${x.target_hcp_first_name || ''} ${x.target_hcp_last_name || ''}`.trim(),
  type: 'HCP',
}));

const hcaChildren = this.hca.map((x: any) => ({
  id: x.target_hca_rcm_id,
  name: x.target_hca_name,

  // IMPORTANT
  level:
    x.target_level ||
    x.target_hca_level ||
    x.level ||
    'HCA',

  type: 'HCA',
}));

this.graph.leftChildren = this.limitChildren(
  hcpChildren,
  this.HCP_LIMIT,
  'HCP'
);

this.graph.rightChildren = this.limitChildren(
  hcaChildren,
  this.HCA_LIMIT,
  'HCA'
);

    this.hasHcpChildren = this.graph.leftChildren.length > 0;
    this.hasHcaChildren = this.graph.rightChildren.length > 0;
  }
private limitChildren(
  children: any[],
  limit: number,
  type: 'HCA' | 'HCP'
) {
  if (!children || children.length <= limit) {
    return children;
  }

  const remaining = children.length - limit;

  return [
    ...children.slice(0, limit),

    {
      id: '',
      name: `+${remaining} more`,
      type,
      isMoreNode: true,
      totalCount: children.length,
    },
  ];
}
 buildAffiliationSummary() {

  // Convert L4 -> HCP
  const searchedLevel =
    this.selectedNodeType?.toUpperCase() === 'L4'
      ? 'HCP'
      : (this.selectedNodeType || '-');

  const totalHcaChildren = this.hca?.length || 0;

  const totalHcpChildren = this.hcp?.length || 0;

  const hierarchyLevels =
    this.hierarchyNodes?.map((x: any) => x.level) || [];

  const l3Count =
    this.hca?.filter((x: any) => {
      return (
        x.target_level === 'L3' ||
        x.level === 'L3' ||
        x.target_hca_level === 'L3'
      );
    })?.length || 0;

  this.affiliationSummary = {
    searchedLevel,
    rcmId: this.rcmId || '-',
    name: this.selectedNodeName || '-',

    totalHierarchyNodes: hierarchyLevels.length,

    totalL3Children: l3Count,

    totalHcaChildren,

    totalHcpChildren,
  };
}
  buildHierarchy() {
    const map = new Map<string, any>();

    // Build parent hierarchy dynamically
    this.parent.forEach((item: any) => {
      // parent node
      if (item.parent_level) {
        map.set(item.parent_level, {
          level: item.parent_level,
          id: item.parent_hca_rcm_id,
          name:
            item.org_name || item.parent_hca_name || item.parent_org_name || item.parent_level,
          isSelected: false,
        });
      }

      // source/current hierarchy node
      if (item.source_level) {
        map.set(item.source_level, {
          level: item.source_level,
          id: item.source_rcm_id,
          name: item.source_hca_name || item.org_name || this.selectedNodeName,
          isSelected: item.source_level === this.selectedNodeType,
        });
      }
    });

    // Ensure selected node always exists
    map.set(this.selectedNodeType, {
      level: this.selectedNodeType,
      id: this.rcmId,
      name: this.selectedNodeName,
      isSelected: true,
    });

    this.hierarchyNodes = Array.from(map.values());

    // Dynamic sorting by numeric level
    this.hierarchyNodes.sort((a: any, b: any) => {
      const levelA = parseInt(a.level.replace(/\D/g, ''), 10);

      const levelB = parseInt(b.level.replace(/\D/g, ''), 10);

      return levelA - levelB;
    });
  }

  drawLines() {

  this.parentLines = [];

  const selectedNode = document.getElementById('selected-node');

  if (!selectedNode) return;

  const selectedRect = selectedNode.getBoundingClientRect();

  const containerRect = document
    .querySelector('.graph-wrap')
    ?.getBoundingClientRect();

  if (!containerRect) return;

  // =========================================
  // LEFT STACK LINE
  // =========================================
  if (this.leftStackRef) {

    const leftRect =
      this.leftStackRef.nativeElement.getBoundingClientRect();

    this.leftLine = {
      x1:
        selectedRect.left -
        containerRect.left +
        selectedRect.width / 2,

      y1:
        selectedRect.bottom -
        containerRect.top,

      x2:
        leftRect.left -
        containerRect.left +
        leftRect.width / 2,

      y2:
        leftRect.top -
        containerRect.top +
        40,
    };
  }

  // =========================================
  // RIGHT STACK LINE
  // =========================================
  if (this.rightStackRef) {

    const rightRect =
      this.rightStackRef.nativeElement.getBoundingClientRect();

    this.rightLine = {
      x1:
        selectedRect.left -
        containerRect.left +
        selectedRect.width / 2,

      y1:
        selectedRect.bottom -
        containerRect.top,

      x2:
        rightRect.left -
        containerRect.left +
        rightRect.width / 2,

      y2:
        rightRect.top -
        containerRect.top +
        40,
    };
  }

  // =========================================
  // HIERARCHY PARENT CONNECTOR LINES
  // =========================================

  const hierarchyNodes =
    this.hierarchyNodeRefs?.toArray() || [];

  for (let i = 0; i < hierarchyNodes.length - 1; i++) {

    const current =
      hierarchyNodes[i].nativeElement.getBoundingClientRect();

    const next =
      hierarchyNodes[i + 1].nativeElement.getBoundingClientRect();

    this.parentLines.push({

      x1:
        current.left -
        containerRect.left +
        current.width / 2,

      y1:
        current.bottom -
        containerRect.top,

      x2:
        next.left -
        containerRect.left +
        next.width / 2,

      y2:
        next.top -
        containerRect.top,

    });
  }
}
  goBack() {
  this.router.navigate(['main', 'crt', 'affiliationView']);
}
}
